import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const ForbiddenPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-900">403</h1>
        <p className="text-xl text-gray-600 mt-2">
          {t('errors.forbidden', 'Access Forbidden')}
        </p>
        <p className="text-gray-500 mt-2">
          {t(
            'errors.noPermission',
            'You do not have permission to access this resource'
          )}
        </p>

        <button
          onClick={handleGoBack}
          className="mt-6 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
        >
          {t('common.goBack', 'Go Back')}
        </button>
      </div>
    </div>
  );
};
